'use client';

import { useState, useEffect } from 'react';
import type { BlogPost } from '@/content/blog/types';
import BlogArticle from './BlogArticle';

interface BlogArticleInteractiveProps {
  post: BlogPost;
  prevPost: BlogPost | null;
  nextPost: BlogPost | null;
  lang?: 'en' | 'de';
}

export default function BlogArticleInteractive({
  post,
  prevPost,
  nextPost,
  lang = 'en',
}: BlogArticleInteractiveProps) {
  const [currentLanguage, setCurrentLanguage] = useState<'en' | 'de'>(lang);

  useEffect(() => {
    // Update language if prop changes
    setCurrentLanguage(lang);

    const handleLanguageChange = (event: CustomEvent<{ language: 'en' | 'de' }>) => {
      setCurrentLanguage(event.detail.language);
    };

    window.addEventListener('languageChange', handleLanguageChange as EventListener);
    return () => {
      window.removeEventListener('languageChange', handleLanguageChange as EventListener);
    };
  }, []);

  return (
    <BlogArticle
      post={post}
      currentLanguage={currentLanguage}
      prevPost={prevPost}
      nextPost={nextPost}
    />
  );
}
